module.exports = __webpack_public_path__ + "assets/c95014ca219b9e38a94bfaeb8fb6dad4.png";